// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__2MdwJ","vLegacy":"SelectSecondary_vLegacy__fFl7n","error":"SelectSecondary_error__tw6HE","disabled":"SelectSecondary_disabled__8M2ad"};